export const CLIENT_PRESENCE_COOLDOWN_MS = 6 * 60 * 60 * 1000;

export function shouldReportClientPresence(
  lastReportedAtMs: number | null | undefined,
  nowMs: number = Date.now(),
): boolean {
  if (lastReportedAtMs == null || !Number.isFinite(lastReportedAtMs)) {
    return true;
  }
  return nowMs - lastReportedAtMs >= CLIENT_PRESENCE_COOLDOWN_MS;
}
